import {classes} from './flex-layout.st.css';

/** @deprecated */
export const FlexLayout = {
    column: {
        /** @deprecated use {@link flexColumnAlignToStart} instead */
        alignToStart: classes.flexColumnAlignToStart,
        /** @deprecated use {@link flexColumnAlignToEnd} instead */
        alignToEnd: classes.flexColumnAlignToEnd,
        /** @deprecated use {@link flexColumnAlignToStart} instead */
        alignToCenter: classes.flexColumnAlignToCenter,
        /** @deprecated use {@link flexColumn} instead */
        default: classes.flexColumnDefault
    },
    row: {
        /** @deprecated use {@link flexRowAlignToStart} instead */
        alignToStart: classes.flexRowAlignToStart,
        /** @deprecated use {@link flexRowAlignToStart} instead */
        alignToTop: classes.flexRowAlignToStart,
        /** @deprecated use {@link flexRowAlignToEnd} instead */
        alignToEnd: classes.flexRowAlignToEnd,
        /** @deprecated use {@link flexRowAlignToEnd} instead */
        alignToBottom: classes.flexRowAlignToEnd,
        /** @deprecated use {@link flexRowAlignToCenter} instead */
        alignToCenter: classes.flexRowAlignToCenter,
        /** @deprecated use {@link flexRowStretch} instead */
        stretch: classes.flexRowStretch,
    },
    /** @deprecated use {@link flexWrap} instead */
    wrap: classes.flexWrap,
    /** @deprecated use {@link flexCenterContent} instead */
    centerContent: classes.flexCenterContent,
    /** @deprecated use {@link flexFillRemainingHorizontalSpace} instead */
    fillRemainingHorizontalSpace: classes.flexFillRemainingSpace,
    /** @deprecated use {@link flexFillRemainingVerticalSpace} instead */
    fillRemainingVerticalSpace: classes.flexFillRemainingVerticalSpace,

    /** @deprecated use {@link flexShrinkInRemainingHorizontalSpace} instead */
    shrinkInRemainingHorizontalSpace: classes.shrinkInRemainingHorizontalSpace,
    /** @deprecated use {@link flexShrinkInRemainingVerticalSpace} instead */
    shrinkInRemainingVerticalSpace: classes.shrinkInRemainingVerticalSpace,

    /** @deprecated use {@link flexHorizontallyJustifyToEnd} instead */
    horizontallyJustifyToEnd: classes.flexHorizontallyJustifyToEnd,
    /** @deprecated use {@link flexVerticallyJustifyToEnd} instead */
    verticallyJustifyToEnd: classes.verticallyJustifyToEnd,

    justifyContent: {
        /** @deprecated use {@link flexJustifyContentSpaceBetween} instead */
        spaceBetween: classes.justifyContentSpaceBetween,
        /** @deprecated use {@link flexJustifyContentCenter} instead */
        toCenter: classes.justifyContentCenter,
        /** @deprecated use {@link flexJustifyContentToEnd} instead */
        toEnd: classes.justifyContentToEnd,
        /** @deprecated use {@link flexJustifyContentToStart} instead */
        toStart: classes.justifyContentToStart,
    },

    /** @deprecated use {@link flexNoShrink} instead */
    noShrink: classes.noShrink,
    alignSelf: {
        /** @deprecated use {@link flexAlignSelfToStart} instead */
        flexStart: classes.flexAlignSelfFlexStart,
        /** @deprecated use {@link flexAlignSelfToEnd} instead */
        flexEnd: classes.flexAlignSelfFlexEnd,
        /** @deprecated use {@link flexAlignSelfToCenter} instead */
        center: classes.flexAlignSelfCenter,
        /** @deprecated use {@link flexAlignSelfAsStretched} instead */
        stretch: classes.flexAlignSelfStretch,
    },
    justifySelf: {
        /** @deprecated use {@link flexJustifySelfToStart} instead */
        flexStart: classes.flexJustifySelfFlexStart,
        /** @deprecated use {@link flexJustifySelfToEnd} instead */
        flexEnd: classes.flexJustifySelfFlexEnd,
        /** @deprecated use {@link flexJustifySelfToCenter} instead */
        center: classes.flexJustifySelfCenter,
        /** @deprecated use {@link flexJustifySelfAsStretched} instead */
        stretch: classes.flexJustifySelfStretch,
    }
};

export enum FlexAlignment {
    FlexStart = 'flexStart',
    FlexEnd = 'flexEnd',
    Center = 'center',
    Stretch = 'stretch',
}
